import { Box, Divider, FormControl, FormLabel } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalTextField from "../../global-fields/GlobalTextField";
import { useFormik } from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthState } from "../../../store/authSlice";
import { selectDataStoreState, setDataStore } from "../../../store/dataSlice";
import { PROPOSAL_FORM } from "../../../constants/apiConstant";
import Editor from "react-simple-wysiwyg";
import {
  areRequiredFieldsFilled,
  parseToNumber,
  normalizeCurrencyToNumber,
  removeCookies,
  USD_FORMATTER,
  initialFormValidations,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import { setUiData } from "../../../store/uiSlice";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeSlideIn } from "../../../constants/motionConstants";
import {
  amountSchemaWithoutRequired,
  amountSchemaWithRequired,
  numberSchemaWithPercentage,
  numberSchemaWithPercentageWithDecimal,
} from "../../../constants/validationSchemas";
import GlobalTextAriaField from "../../global-fields/GlobalTextArea";
import GlobalRadio from "../../global-fields/GlobalRadio";
import { MANDATORY_QUES } from "../../../constants/constants";

const StepElevenForm = ({ leftGridWidth }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, selectedClient } = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep11Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const [disableDraft, setDisableDraft] = useState(false);

  const [html, setHtml] = useState("");

  function onChange(e) {
    setHtml(e.target.value);
    console.log(e.target.value);
  }

  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {
      ...e,
      user_id: user?.id,
      proposal_id,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
      // setting_unsetting: normalizeCurrencyToNumber(e.setting_unsetting),
      // employee_infidelity: normalizeCurrencyToNumber(e.employee_infidelity),
      setting_unsetting: normalizeCurrencyToNumber(e.setting_unsetting),
      // employee_infidelity: normalizeCurrencyToNumber(e.employee_infidelity),
      employee_infidelity_limit: normalizeCurrencyToNumber(
        e.employee_infidelity_limit
      ),
      employee_infidelity_deductible: normalizeCurrencyToNumber(
        e.employee_infidelity_deductible
      ),
      disappearance_coverage_limit: normalizeCurrencyToNumber(
        e.disappearance_coverage_limit
      ),
      workmanship_limit: normalizeCurrencyToNumber(e.workmanship_limit),
      workmanship_deductible: normalizeCurrencyToNumber(
        e.workmanship_deductible
      ),
      wearing_coverage_limit: normalizeCurrencyToNumber(
        e.wearing_coverage_limit
      ),
      // wearing_coverage_deductible: normalizeCurrencyToNumber(
      //   e.wearing_coverage_deductible
      // ),
      travel_insurance_limit: normalizeCurrencyToNumber(
        e.travel_insurance_limit
      ),

      additional_travel_limit: (e.additional_travel_limit || []).map(
        (item) => ({
          name: item.name,
          limit: normalizeCurrencyToNumber(item.limit),
        })
      ),

      additional_loss_payee_limit: (
        e.additional_loss_payee_limit || []
      ).map((item) => ({
        name: item.name,
        limit: normalizeCurrencyToNumber(item.limit),
      })),
      on_premises_deductible: normalizeCurrencyToNumber(
        e.on_premises_deductible
      ),
      off_premises_deductible: normalizeCurrencyToNumber(
        e.off_premises_deductible
      ),


      loss_payee_limit: normalizeCurrencyToNumber(e.loss_payee_limit),

      // basis_valuation_own_goods: normalizeCurrencyToNumber(
      //   e.basis_valuation_own_goods
      // ),

      // basis_valuation_inward_outward: normalizeCurrencyToNumber(
      //   e.basis_valuation_inward_outward
      // ),

      // basis_valuation_goods_sold: normalizeCurrencyToNumber(
      //   e.basis_valuation_goods_sold
      // ),

      // basis_valuation_sendings: normalizeCurrencyToNumber(
      //   e.basis_valuation_sendings
      // ),
      basis_valuation_own_goods: e.basis_valuation_own_goods,

      basis_valuation_inward_outward: e.basis_valuation_inward_outward,

      basis_valuation_goods_sold: e.basis_valuation_goods_sold,

      basis_valuation_sendings: e.basis_valuation_sendings,
    };
    if (user?.user_type === "agent") {
      data = { ...data, user_id: selectedClient?.user_id, agent_id: user?.id };
    }
    const options = {
      method: PROPOSAL_FORM.method,
      headers: PROPOSAL_FORM.headers,
      body: JSON.stringify(data),
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(setUiData({ showLoader: false }));
          formik.resetForm();
        } else if (res.status == 1) {
          formik.resetForm();
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({ type: "error", message: error });
        console.log("error", error);
        dispatch(setUiData({ showLoader: false }));
        navigate("/");
        formik.resetForm();
      });
  };

  const propStep11DataMemoize = useMemo(
    () => (propStep11Data ? propStep11Data : null),
    [propStep11Data]
  );

  const initialValues = {
    step: 11,
    setting_unsetting:
      propStep11DataMemoize?.setting_unsetting == 0 ||
        propStep11DataMemoize?.setting_unsetting == "0" ||
        propStep11DataMemoize?.setting_unsetting
        ? USD_FORMATTER.format(propStep11DataMemoize?.setting_unsetting)
        : "",
    // employee_infidelity:
    //   propStep11DataMemoize?.employee_infidelity == 0 ||
    //     propStep11DataMemoize?.employee_infidelity == "0" ||
    //     propStep11DataMemoize?.employee_infidelity
    //     ? USD_FORMATTER.format(propStep11DataMemoize?.employee_infidelity)
    //     : "",
    employee_infidelity:
      propStep11DataMemoize?.employee_infidelity === "1" ||
        propStep11DataMemoize?.employee_infidelity === 1
        ? 1
        : 0,

    employee_infidelity_limit:
      propStep11DataMemoize?.employee_infidelity_limit == 0 ||
        propStep11DataMemoize?.employee_infidelity_limit == "0" ||
        propStep11DataMemoize?.employee_infidelity_limit
        ? USD_FORMATTER.format(propStep11DataMemoize?.employee_infidelity_limit)
        : null,
    employee_infidelity_deductible:
      propStep11DataMemoize?.employee_infidelity_deductible == 0 ||
        propStep11DataMemoize?.employee_infidelity_deductible == "0" ||
        propStep11DataMemoize?.employee_infidelity_deductible
        ? USD_FORMATTER.format(propStep11DataMemoize?.employee_infidelity_deductible)
        : null,

    comment: propStep11DataMemoize?.comment ?? "",

    no_claim_bonus:
      propStep11DataMemoize?.no_claim_bonus === "1" ||
        propStep11DataMemoize?.no_claim_bonus === 1
        ? 1
        : 0,

    no_claim_bonus_percentage:
      propStep11DataMemoize?.no_claim_bonus_percentage == 0
        ? "0"
        : propStep11DataMemoize?.no_claim_bonus_percentage
          ? propStep11DataMemoize?.no_claim_bonus_percentage.toString()
          : null,
    disappearance_coverage:
      propStep11DataMemoize?.disappearance_coverage === "1" ||
        propStep11DataMemoize?.disappearance_coverage === 1
        ? 1
        : 0,
    disappearance_coverage_limit:
      propStep11DataMemoize?.disappearance_coverage_limit == 0 ||
        propStep11DataMemoize?.disappearance_coverage_limit == "0" ||
        propStep11DataMemoize?.disappearance_coverage_limit
        ? USD_FORMATTER.format(
          propStep11DataMemoize?.disappearance_coverage_limit
        )
        : null,

    workmanship:
      propStep11DataMemoize?.workmanship === "1" ||
        propStep11DataMemoize?.workmanship === 1
        ? 1
        : 0,

    workmanship_limit:
      propStep11DataMemoize?.workmanship_limit == 0 ||
        propStep11DataMemoize?.workmanship_limit == "0" ||
        propStep11DataMemoize?.workmanship_limit
        ? USD_FORMATTER.format(propStep11DataMemoize?.workmanship_limit)
        : null,
    workmanship_deductible:
      propStep11DataMemoize?.workmanship_deductible == 0 ||
        propStep11DataMemoize?.workmanship_deductible == "0" ||
        propStep11DataMemoize?.workmanship_deductible
        ? USD_FORMATTER.format(propStep11DataMemoize?.workmanship_deductible)
        : null,

    wearing_coverage:
      propStep11DataMemoize?.wearing_coverage === "1" ||
        propStep11DataMemoize?.wearing_coverage === 1
        ? 1
        : 0,

    wearing_coverage_limit:
      propStep11DataMemoize?.wearing_coverage_limit == 0 ||
        propStep11DataMemoize?.wearing_coverage_limit == "0" ||
        propStep11DataMemoize?.wearing_coverage_limit
        ? USD_FORMATTER.format(propStep11DataMemoize?.wearing_coverage_limit)
        : null,
    // wearing_coverage_deductible:
    //   propStep11DataMemoize?.wearing_coverage_deductible == 0 ||
    //     propStep11DataMemoize?.wearing_coverage_deductible == "0" ||
    //     propStep11DataMemoize?.wearing_coverage_deductible
    //     ? USD_FORMATTER.format(
    //       propStep11DataMemoize?.wearing_coverage_deductible
    //     )
    //     : null,

    loss_payee:
      propStep11DataMemoize?.loss_payee === "1" ||
        propStep11DataMemoize?.loss_payee === 1
        ? 1
        : 0,
    loss_payee_comment: propStep11DataMemoize?.loss_payee_comment ?? "",



    loss_payee_limit:
      propStep11DataMemoize?.loss_payee_limit == 0 ||
        propStep11DataMemoize?.loss_payee_limit == "0" ||
        propStep11DataMemoize?.loss_payee_limit
        ? USD_FORMATTER.format(propStep11DataMemoize?.loss_payee_limit)
        : null,


    deductible_amendment_clause:
      propStep11DataMemoize?.deductible_amendment_clause === "1" ||
        propStep11DataMemoize?.deductible_amendment_clause === 1
        ? 1
        : 0,
    deductible_amendment_value: propStep11DataMemoize?.deductible_amendment_value ?? "",

    // employee_dishonesty:
    //   propStep11DataMemoize?.employee_dishonesty === "1" ||
    //     propStep11DataMemoize?.employee_dishonesty === 1
    //     ? 1
    //     : 0,
    // employee_dishonesty_comment:
    //   propStep11DataMemoize?.employee_dishonesty_comment ?? "",
    tria_insurance:
      propStep11DataMemoize?.tria_insurance === "1" ||
        propStep11DataMemoize?.tria_insurance === 1
        ? 1
        : 0,
    tpi:
      propStep11DataMemoize?.tpi === "1" || propStep11DataMemoize?.tpi === 1
        ? 1
        : 0,
    // tpi_comment:
    //   propStep11DataMemoize?.tpi_comment ?? "",

    carryings_exhibitions:
      propStep11DataMemoize?.carryings_exhibitions === "1" ||
        propStep11DataMemoize?.carryings_exhibitions === 1
        ? 1
        : 0,
    // carryings_exhibitions_comment:
    //   propStep11DataMemoize?.carryings_exhibitions_comment ?? "",

    roadstock:
      propStep11DataMemoize?.roadstock === "1" ||
        propStep11DataMemoize?.roadstock === 1
        ? 1
        : 0,
    // roadstock_comment:
    //   propStep11DataMemoize?.roadstock_comment ?? "",

    memo_extension:
      propStep11DataMemoize?.memo_extension === "1" ||
        propStep11DataMemoize?.memo_extension === 1
        ? 1
        : 0,
    // memo_extension_comment:
    //   propStep11DataMemoize?.memo_extension_comment ?? "",

    joint_venture:
      propStep11DataMemoize?.joint_venture === "1" ||
        propStep11DataMemoize?.joint_venture === 1
        ? 1
        : 0,
    // joint_venture_comment:
    //   propStep11DataMemoize?.joint_venture_comment ?? "",

    incoming_shipments:
      propStep11DataMemoize?.incoming_shipments === "1" ||
        propStep11DataMemoize?.incoming_shipments === 1
        ? 1
        : 0,
    // incoming_shipments_comment:
    //   propStep11DataMemoize?.incoming_shipments_comment ?? "",

    excess_shipments:
      propStep11DataMemoize?.excess_shipments === "1" ||
        propStep11DataMemoize?.excess_shipments === 1
        ? 1
        : 0,
    // excess_shipments_comment:
    //   propStep11DataMemoize?.excess_shipments_comment ?? "",

    trunk_show_exhibition:
      propStep11DataMemoize?.trunk_show_exhibition === "1" ||
        propStep11DataMemoize?.trunk_show_exhibition === 1
        ? 1
        : 0,
    // trunk_show_exhibition_comment:
    //   propStep11DataMemoize?.trunk_show_exhibition_comment ?? "",

    travel_insurance_increase:
      propStep11DataMemoize?.travel_insurance_increase === "1" ||
        propStep11DataMemoize?.travel_insurance_increase === 1
        ? 1
        : 0,

    travel_insurance_name: propStep11DataMemoize?.travel_insurance_name ?? "",
    wearing_coverage_name: propStep11DataMemoize?.wearing_coverage_name ?? "",

    travel_insurance_limit:
      propStep11DataMemoize?.travel_insurance_limit == 0 ||
        propStep11DataMemoize?.travel_insurance_limit == "0" ||
        propStep11DataMemoize?.travel_insurance_limit
        ? USD_FORMATTER.format(propStep11DataMemoize?.travel_insurance_limit)
        : null,


    additional_travel_limit:
      Array.isArray(propStep11DataMemoize?.additional_travel_limit)
        ? propStep11DataMemoize.additional_travel_limit.map((item) => ({
          name: item?.name ?? "",
          limit:
            item?.limit == 0 ||
              item?.limit == "0" ||
              item?.limit
              ? USD_FORMATTER.format(item.limit)
              : "",
        }))
        : [],


    additional_loss_payee_limit:
      Array.isArray(propStep11DataMemoize?.additional_loss_payee_limit)
        ? propStep11DataMemoize.additional_loss_payee_limit.map((item) => ({
          name: item?.name ?? "",
          limit:
            item?.limit == 0 ||
              item?.limit == "0" ||
              item?.limit
              ? USD_FORMATTER.format(item.limit)
              : "",
        }))
        : [],
    territorial_limit_extension:
      propStep11DataMemoize?.territorial_limit_extension === "1" ||
        propStep11DataMemoize?.territorial_limit_extension === 1
        ? 1
        : 0,

    overnight_shipments_extension_clause:
      propStep11DataMemoize?.overnight_shipments_extension_clause === "1" ||
        propStep11DataMemoize?.overnight_shipments_extension_clause === 1
        ? 1
        : 0,

    locked_showcase_endorsement_clause:
      propStep11DataMemoize?.locked_showcase_endorsement_clause === "1" ||
        propStep11DataMemoize?.locked_showcase_endorsement_clause === 1
        ? 1
        : 0,

    window_display_extension_clause:
      propStep11DataMemoize?.window_display_extension_clause === "1" ||
        propStep11DataMemoize?.window_display_extension_clause === 1
        ? 1
        : 0,

    on_premises_deductible:
      propStep11DataMemoize?.on_premises_deductible == 0 ||
        propStep11DataMemoize?.on_premises_deductible == "0" ||
        propStep11DataMemoize?.on_premises_deductible
        ? USD_FORMATTER.format(propStep11DataMemoize?.on_premises_deductible)
        : null,

    off_premises_deductible:
      propStep11DataMemoize?.off_premises_deductible == 0 ||
        propStep11DataMemoize?.off_premises_deductible == "0" ||
        propStep11DataMemoize?.off_premises_deductible
        ? USD_FORMATTER.format(propStep11DataMemoize?.off_premises_deductible)
        : null,


    //   basis_of_valuation_clause:
    // propStep11DataMemoize?.basis_of_valuation_clause === "1" ||
    // propStep11DataMemoize?.basis_of_valuation_clause === 1
    //   ? 1
    //   : 0,
    basis_of_valuation_clause: 1,
    // basis_valuation_own_goods:
    //   propStep11DataMemoize?.basis_valuation_own_goods
    //     ? USD_FORMATTER.format(propStep11DataMemoize?.basis_valuation_own_goods)
    //     : null,

    // basis_valuation_inward_outward:
    //   propStep11DataMemoize?.basis_valuation_inward_outward
    //     ? USD_FORMATTER.format(propStep11DataMemoize?.basis_valuation_inward_outward)
    //     : null,

    // basis_valuation_goods_sold:
    //   propStep11DataMemoize?.basis_valuation_goods_sold
    //     ? USD_FORMATTER.format(propStep11DataMemoize?.basis_valuation_goods_sold)
    //     : null,

    // basis_valuation_sendings:
    //   propStep11DataMemoize?.basis_valuation_sendings
    //     ? USD_FORMATTER.format(propStep11DataMemoize?.basis_valuation_sendings)
    //     : null,

    basis_valuation_own_goods:
      propStep11DataMemoize?.basis_valuation_own_goods ?? "",

    basis_valuation_inward_outward:
      propStep11DataMemoize?.basis_valuation_inward_outward ?? "",

    basis_valuation_goods_sold:
      propStep11DataMemoize?.basis_valuation_goods_sold ?? "",

    basis_valuation_sendings:
      propStep11DataMemoize?.basis_valuation_sendings ?? "",
    // territorial_limit_extension_comment:
    //   propStep11DataMemoize?.territorial_limit_extension_comment ?? "",


  };

  // useEffect(() => {
  //   if (propStep11DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep11DataMemoize]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      setting_unsetting: amountSchemaWithoutRequired,
      // employee_infidelity: amountSchemaWithoutRequired,
      employee_infidelity: Yup.number(),
      employee_infidelity_limit: Yup.string().when("employee_infidelity", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => amountSchemaWithRequired,
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
      employee_infidelity_deductible: Yup.string().when("employee_infidelity", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => amountSchemaWithRequired,
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
      workmanship: Yup.number(),
      workmanship_limit: Yup.string().when("workmanship", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => amountSchemaWithRequired,
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
      workmanship_deductible: Yup.string().when("workmanship", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => amountSchemaWithRequired,
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
      wearing_coverage: Yup.number(),
      wearing_coverage_limit: Yup.string().when("wearing_coverage", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => amountSchemaWithRequired,
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
      // wearing_coverage_deductible: Yup.string().when("wearing_coverage", {
      //   is: (val) => val === "1" || val === 1,
      //   then: (schema) => amountSchemaWithRequired,
      //   otherwise: (schema) => schema.notRequired().nullable(),
      // }),
      no_claim_bonus: Yup.number(),
      no_claim_bonus_percentage: Yup.string().when("no_claim_bonus", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => numberSchemaWithPercentageWithDecimal,
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
      disappearance_coverage: Yup.number(),
      disappearance_coverage_limit: Yup.string().when(
        "disappearance_coverage",
        {
          is: (val) => val === "1" || val === 1,
          then: (schema) => amountSchemaWithRequired,
          otherwise: (schema) => schema.notRequired().nullable(),
        }
      ),
      loss_payee: Yup.number(),
      loss_payee_comment: Yup.string().when("loss_payee", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => schema.required(MANDATORY_QUES),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

      deductible_amendment_clause: Yup.number(),
      deductible_amendment_value: Yup.string().when("deductible_amendment_clause", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => schema.required(MANDATORY_QUES),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),


      
      // employee_dishonesty: Yup.number(),
      tria_insurance: Yup.number(),
      tpi: Yup.number(),
      carryings_exhibitions: Yup.number(),
      roadstock: Yup.number(),
      memo_extension: Yup.number(),
      joint_venture: Yup.number(),
      incoming_shipments: Yup.number(),
      excess_shipments: Yup.number(),
      trunk_show_exhibition: Yup.number(),
      travel_insurance_increase: Yup.number(),
      travel_insurance_name: Yup.string().when("travel_insurance_increase", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => schema.required(MANDATORY_QUES),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
      travel_insurance_limit: Yup.string().when("travel_insurance_increase", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => amountSchemaWithRequired,
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

      additional_travel_limit: Yup.array().of(
        Yup.object({
          name: Yup.string().trim(),
          limit: Yup.string(),
        })
      ),

      loss_payee_limit: Yup.string().when("loss_payee", {
        is: (val) => val === "1" || val === 1,
        then: (schema) => amountSchemaWithRequired,
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

      territorial_limit_extension: Yup.number(),
      on_premises_deductible: amountSchemaWithoutRequired,
      off_premises_deductible: amountSchemaWithoutRequired,

      basis_of_valuation_clause: Yup.number(),

      basis_valuation_own_goods: Yup.string()
        .trim(),
      //.required(MANDATORY_QUES),

      basis_valuation_inward_outward: Yup.string()
        .trim(),
      //.required(MANDATORY_QUES),

      basis_valuation_goods_sold: Yup.string()
        .trim(),
      //.required(MANDATORY_QUES),

      basis_valuation_sendings: Yup.string()
        .trim(),
      // .required(MANDATORY_QUES),

      //       basis_of_valuation_clause: Yup.number(),

      // basis_valuation_own_goods: Yup.string().when(
      //   "basis_of_valuation_clause",
      //   {
      //     is: (val) => val === 1 || val === "1",
      //     then: () => amountSchemaWithRequired,
      //     otherwise: (schema) => schema.notRequired().nullable(),
      //   }
      // ),

      // basis_valuation_inward_outward: Yup.string().when(
      //   "basis_of_valuation_clause",
      //   {
      //     is: (val) => val === 1 || val === "1",
      //     then: () => amountSchemaWithRequired,
      //     otherwise: (schema) => schema.notRequired().nullable(),
      //   }
      // ),

      // basis_valuation_goods_sold: Yup.string().when(
      //   "basis_of_valuation_clause",
      //   {
      //     is: (val) => val === 1 || val === "1",
      //     then: () => amountSchemaWithRequired,
      //     otherwise: (schema) => schema.notRequired().nullable(),
      //   }
      // ),

      // basis_valuation_sendings: Yup.string().when(
      //   "basis_of_valuation_clause",
      //   {
      //     is: (val) => val === 1 || val === "1",
      //     then: () => amountSchemaWithRequired,
      //     otherwise: (schema) => schema.notRequired().nullable(),
      //   }
      // ),
    }),
    onSubmit: (values) => {
      //console.log("Form submitted 11:", values);
      handleStepData(values);
    },
  });

  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 11) {
          return { ...item, status: 2 };
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  // console.log("propStep11DataMemoize", propStep11DataMemoize, initialValues)

  const handleAmountFieldChangeOLD = (e, fieldName) => {
    const rawValue = e.target.value;
    const numericValue = parseToNumber(rawValue);
    formik.setFieldValue(
      fieldName,
      numericValue !== "" ? USD_FORMATTER.format(numericValue) : ""
    );
  };

  const handleAmountFieldChange = (e, fieldName) => {
    let rawValue = e.target.value;

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Extract numeric part
    const numericValue = parseToNumber(rawValue);

    // Allow typing "$" or "$." without formatting
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas, keep decimal part as typed
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      // Format integer with commas
      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));

      // Append decimal part if exists, limit to 2 digits
      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);
  };



  const handleSaveDraft = useCallback(() => {
    const { values } = formik;
    setDisableDraft(true);
    let vals = { ...values, save_draft: true };
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);


  const handleAdditionalTravelChange = (index, field, value) => {
    const updated = [...(formik.values.additional_travel_limit || [])];

    updated[index] = {
      ...updated[index],
      [field]: value,
    };

    formik.setFieldValue("additional_travel_limit", updated);
  };

  const handleAdditionalTravelLimitChange = (e, index) => {
    let rawValue = e.target.value;

    if (!rawValue.startsWith("$")) {
      rawValue = "$" + rawValue;
    }

    const numericValue = parseToNumber(rawValue);

    if (rawValue === "$" || rawValue === "$.") {
      handleAdditionalTravelChange(index, "limit", rawValue);
      return;
    }

    let formatted = "$";

    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      formatted += new Intl.NumberFormat("en-US").format(
        Number(integerPart)
      );

      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    handleAdditionalTravelChange(index, "limit", formatted);
  };

  const handleAddAdditionalTravelLimit = () => {
    formik.setFieldValue("additional_travel_limit", [
      ...(formik.values.additional_travel_limit || []),
      {
        name: "",
        limit: "",
      },
    ]);
  };

  const handleRemoveAdditionalTravelLimit = (index) => {
    const updated = [...(formik.values.additional_travel_limit || [])];

    updated.splice(index, 1);

    formik.setFieldValue("additional_travel_limit", updated);
  };

  const handleAdditionalLossPayeeChange = (index, field, value) => {
    const updated = [
      ...(formik.values.additional_loss_payee_limit || []),
    ];

    updated[index] = {
      ...updated[index],
      [field]: value,
    };

    formik.setFieldValue("additional_loss_payee_limit", updated);
  };

  const handleAdditionalLossPayeeLimitChange = (e, index) => {
    let rawValue = e.target.value;

    if (!rawValue.startsWith("$")) {
      rawValue = "$" + rawValue;
    }

    const numericValue = parseToNumber(rawValue);

    if (rawValue === "$" || rawValue === "$.") {
      handleAdditionalLossPayeeChange(index, "limit", rawValue);
      return;
    }

    let formatted = "$";

    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      formatted += new Intl.NumberFormat("en-US").format(
        Number(integerPart)
      );

      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    handleAdditionalLossPayeeChange(index, "limit", formatted);
  };

  const handleAddAdditionalLossPayeeLimit = () => {
    formik.setFieldValue("additional_loss_payee_limit", [
      ...(formik.values.additional_loss_payee_limit || []),
      {
        name: "",
        limit: "",
      },
    ]);
  };

  const handleRemoveAdditionalLossPayeeLimit = (index) => {
    const updated = [
      ...(formik.values.additional_loss_payee_limit || []),
    ];

    updated.splice(index, 1);

    formik.setFieldValue("additional_loss_payee_limit", updated);
  };

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Additional</h2>
            <h2 className={style.formTitleh2}>21) Additional Coverage</h2>
            <form
              onSubmit={handleCustomSubmit}
              autoComplete="false"
              autoSave="false"
            >
              {/* <Grid container spacing={2} sx={{ mt: 3 }}>
                <Grid size={{ xs: 12, md: 4 }}>
                  <FormControl fullWidth>
                    <FormLabel sx={{ mb: 1 }}>Setting / Unsetting</FormLabel>
                  </FormControl>
                  <GlobalTextField
                    type="text"
                    placeH="$"
                    value={formik.values.setting_unsetting}
                    onChange={(e) =>
                      handleAmountFieldChange(e, "setting_unsetting")
                    }
                    onBlur={formik.handleBlur}
                    id="setting_unsetting"
                    name="setting_unsetting"
                    error={
                      formik.touched.setting_unsetting &&
                      Boolean(formik.errors.setting_unsetting)
                    }
                    helperText={
                      formik.touched.setting_unsetting &&
                      formik.errors.setting_unsetting
                    }
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                  <FormControl fullWidth>
                    <FormLabel sx={{ mb: 1 }}>Employee Infidelity</FormLabel>
                  </FormControl>
                  <GlobalTextField
                    type="text"
                    placeH="$"
                    value={formik.values.employee_infidelity}
                    onChange={(e) =>
                      handleAmountFieldChange(e, "employee_infidelity")
                    }
                    onBlur={formik.handleBlur}
                    id="employee_infidelity"
                    name="employee_infidelity"
                    error={
                      formik.touched.employee_infidelity &&
                      Boolean(formik.errors.employee_infidelity)
                    }
                    helperText={
                      formik.touched.employee_infidelity &&
                      formik.errors.employee_infidelity
                    }
                  />
                </Grid> */}
              {/* <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel sx={{ mb: 1 }}>Comments (if any)</FormLabel>
                  </FormControl>
                  <GlobalTextAriaField
                    row={2}
                    placeH="Type here..."
                    id="comment"
                    name="comment"
                    type="comment"
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.comment && Boolean(formik.errors.comment)
                    }
                    helperText={formik.touched.comment && formik.errors.comment}
                  />
                </Grid> */}
              {/* </Grid> */}
              <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                  <h2 className={style.formTitleh2}>
                    24) Disappearance Coverage
                  </h2>
                </Grid> */}
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Employee Infidelity</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.employee_infidelity == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("employee_infidelity", 1);
                        }}
                        error={
                          formik.touched.employee_infidelity &&
                          Boolean(formik.errors.employee_infidelity)
                        }
                        errorText={
                          formik.touched.employee_infidelity &&
                          formik.errors.employee_infidelity
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.employee_infidelity != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            employee_infidelity: 0,
                            employee_infidelity_limit: null,
                            employee_infidelity_deductible: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                {formik.values.employee_infidelity == 1 ? (
                  // <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth>
                      <FormLabel>Limit *</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextField
                          type="text"
                          placeH="$"
                          value={formik.values.employee_infidelity_limit}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "employee_infidelity_limit"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="employee_infidelity_limit"
                          name="employee_infidelity_limit"
                          error={
                            formik.touched.employee_infidelity_limit &&
                            Boolean(formik.errors.employee_infidelity_limit)
                          }
                          helperText={
                            formik.touched.employee_infidelity_limit &&
                            formik.errors.employee_infidelity_limit
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}
                {formik.values.employee_infidelity == 1 ? (
                  <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth>
                      <FormLabel>Deductible *</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextField
                          type="text"
                          placeH="$"
                          value={formik.values.employee_infidelity_deductible}
                          onChange={(e) =>
                            handleAmountFieldChange(e, "employee_infidelity_deductible")
                          }
                          onBlur={formik.handleBlur}
                          id="employee_infidelity_deductible"
                          name="employee_infidelity_deductible"
                          error={
                            formik.touched.employee_infidelity_deductible &&
                            Boolean(formik.errors.employee_infidelity_deductible)
                          }
                          helperText={
                            formik.touched.employee_infidelity_deductible &&
                            formik.errors.employee_infidelity_deductible
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                ) : null}
              </Grid>

              {/* {/* */}
              <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                  <h2 className={style.formTitleh2}>
                    24) Disappearance Coverage
                  </h2>
                </Grid> */}
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Workmanship Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.workmanship == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("workmanship", 1);
                        }}
                        error={
                          formik.touched.workmanship &&
                          Boolean(formik.errors.workmanship)
                        }
                        errorText={
                          formik.touched.workmanship &&
                          formik.errors.workmanship
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.workmanship != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            workmanship: 0,
                            workmanship_limit: null,
                            workmanship_deductible: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                {formik.values.workmanship == 1 ? (
                  // <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth>
                      <FormLabel>Limit *</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextField
                          type="text"
                          placeH="$"
                          value={formik.values.workmanship_limit}
                          onChange={(e) =>
                            handleAmountFieldChange(e, "workmanship_limit")
                          }
                          onBlur={formik.handleBlur}
                          id="workmanship_limit"
                          name="workmanship_limit"
                          error={
                            formik.touched.workmanship_limit &&
                            Boolean(formik.errors.workmanship_limit)
                          }
                          helperText={
                            formik.touched.workmanship_limit &&
                            formik.errors.workmanship_limit
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}
                {formik.values.workmanship == 1 ? (
                  <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth>
                      <FormLabel>Deductible *</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextField
                          type="text"
                          placeH="$"
                          value={formik.values.workmanship_deductible}
                          onChange={(e) =>
                            handleAmountFieldChange(e, "workmanship_deductible")
                          }
                          onBlur={formik.handleBlur}
                          id="workmanship_deductible"
                          name="workmanship_deductible"
                          error={
                            formik.touched.workmanship_deductible &&
                            Boolean(formik.errors.workmanship_deductible)
                          }
                          helperText={
                            formik.touched.workmanship_deductible &&
                            formik.errors.workmanship_deductible
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                ) : null}
              </Grid>

              <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                  <h2 className={style.formTitleh2}>
                    24) Disappearance Coverage
                  </h2>
                </Grid> */}
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Wearing Coverage?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.wearing_coverage == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("wearing_coverage", 1);
                        }}
                        error={
                          formik.touched.wearing_coverage &&
                          Boolean(formik.errors.wearing_coverage)
                        }
                        errorText={
                          formik.touched.wearing_coverage &&
                          formik.errors.wearing_coverage
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.wearing_coverage != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            wearing_coverage: 0,
                            wearing_coverage_limit: null,
                            //wearing_coverage_deductible: null,
                            wearing_coverage_name: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>

                {formik.values.wearing_coverage == 1 ? (
                  <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth>
                      <FormLabel>Name *</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextField
                          type="text"
                          placeH=""
                          value={formik.values.wearing_coverage_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          id="wearing_coverage_name"
                          name="wearing_coverage_name"
                          error={
                            formik.touched.wearing_coverage_name &&
                            Boolean(formik.errors.wearing_coverage_name)
                          }
                          helperText={
                            formik.touched.wearing_coverage_name &&
                            formik.errors.wearing_coverage_name
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                ) : null}
                {formik.values.wearing_coverage == 1 ? (
                  // <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth>
                      <FormLabel>Limit *</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextField
                          type="text"
                          placeH="$"
                          value={formik.values.wearing_coverage_limit}
                          onChange={(e) =>
                            handleAmountFieldChange(e, "wearing_coverage_limit")
                          }
                          onBlur={formik.handleBlur}
                          id="wearing_coverage_limit"
                          name="wearing_coverage_limit"
                          error={
                            formik.touched.wearing_coverage_limit &&
                            Boolean(formik.errors.wearing_coverage_limit)
                          }
                          helperText={
                            formik.touched.wearing_coverage_limit &&
                            formik.errors.wearing_coverage_limit
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}

              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                  <h2 className={style.formTitleh2}>
                    24) Disappearance Coverage
                  </h2>
                </Grid> */}
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>No Claim Bonus?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.no_claim_bonus == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("no_claim_bonus", 1);
                        }}
                        error={
                          formik.touched.no_claim_bonus &&
                          Boolean(formik.errors.no_claim_bonus)
                        }
                        errorText={
                          formik.touched.no_claim_bonus &&
                          formik.errors.no_claim_bonus
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.no_claim_bonus != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            no_claim_bonus: 0,
                            no_claim_bonus_percentage: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {formik.values.no_claim_bonus == 1 ? (
                  <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth>
                      <FormLabel>Percentage *</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextField
                          type="text"
                          placeH="%"
                          value={formik.values.no_claim_bonus_percentage}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          id="no_claim_bonus_percentage"
                          name="no_claim_bonus_percentage"
                          error={
                            formik.touched.no_claim_bonus_percentage &&
                            Boolean(formik.errors.no_claim_bonus_percentage)
                          }
                          helperText={
                            formik.touched.no_claim_bonus_percentage &&
                            formik.errors.no_claim_bonus_percentage
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Mysterious Disappearance?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.disappearance_coverage == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("disappearance_coverage", 1);
                        }}
                        error={
                          formik.touched.disappearance_coverage &&
                          Boolean(formik.errors.disappearance_coverage)
                        }
                        errorText={
                          formik.touched.disappearance_coverage &&
                          formik.errors.disappearance_coverage
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.disappearance_coverage != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            disappearance_coverage: 0,
                            disappearance_coverage_limit: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {formik.values.disappearance_coverage == 1 ? (
                  <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth>
                      <FormLabel>Limit </FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextField
                          type="text"
                          placeH="$"
                          value={formik.values.disappearance_coverage_limit}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "disappearance_coverage_limit"
                            )
                          }
                          //onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          id="disappearance_coverage_limit"
                          name="disappearance_coverage_limit"
                          error={
                            formik.touched.disappearance_coverage_limit &&
                            Boolean(formik.errors.disappearance_coverage_limit)
                          }
                          helperText={
                            formik.touched.disappearance_coverage_limit &&
                            formik.errors.disappearance_coverage_limit
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Loss Payee Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.loss_payee == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("loss_payee", 1);
                        }}
                        error={
                          formik.touched.loss_payee &&
                          Boolean(formik.errors.loss_payee)
                        }
                        errorText={
                          formik.touched.loss_payee && formik.errors.loss_payee
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.loss_payee != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            loss_payee: 0,
                            loss_payee_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {formik.values.loss_payee == 1 ? (
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Grid container spacing={2} sx={{ mt: 0 }}>

                      {/* LOSS PAYEE NAME */}
                      <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <FormLabel>State the Loss Payee *</FormLabel>
                        </FormControl>

                        <GlobalTextField
                          type="text"
                          placeH="Who is the Loss Payee?"
                          value={formik.values.loss_payee_comment}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          id="loss_payee_comment"
                          name="loss_payee_comment"
                          error={
                            formik.touched.loss_payee_comment &&
                            Boolean(formik.errors.loss_payee_comment)
                          }
                          helperText={
                            formik.touched.loss_payee_comment &&
                            formik.errors.loss_payee_comment
                          }
                        />
                      </Grid>

                      {/* LIMIT */}
                      <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <FormLabel>Limit *</FormLabel>
                        </FormControl>

                        <GlobalTextField
                          type="text"
                          placeH="$"
                          value={formik.values.loss_payee_limit}
                          onChange={(e) =>
                            handleAmountFieldChange(e, "loss_payee_limit")
                          }
                          onBlur={formik.handleBlur}
                          id="loss_payee_limit"
                          name="loss_payee_limit"
                          error={
                            formik.touched.loss_payee_limit &&
                            Boolean(formik.errors.loss_payee_limit)
                          }
                          helperText={
                            formik.touched.loss_payee_limit &&
                            formik.errors.loss_payee_limit
                          }
                        />
                      </Grid>

                      {/* ADD BUTTON */}
                      <Grid
                        size={{ xs: 12, md: 4 }}
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          pb: "4px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={handleAddAdditionalLossPayeeLimit}
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                            fontSize: "16px",
                            padding: 0,
                            marginLeft: "8px",
                          }}
                        >
                          <span
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "50%",
                              background: "#000",
                              color: "#fff",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "22px",
                              fontWeight: "400",
                              lineHeight: 1,
                            }}
                          >
                            +
                          </span>

                          <span>Add</span>
                        </button>
                      </Grid>

                    </Grid>

                    {/* ADDITIONAL LOSS PAYEE LIMITS */}
                    {formik.values.additional_loss_payee_limit?.map((item, index) => (
                      <Box key={index} sx={{ mt: 4 }}>

                        {/* SEPARATOR */}
                        <Grid container>
                          <Grid size={{ xs: 12, md: 8 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                mb: 3.5,
                              }}
                            >
                              <Divider sx={{ flex: 1 }} />

                              <Box
                                sx={{
                                  mx: 1.5,
                                  px: 1.5,
                                  height: 42,
                                  borderRadius: "24px",
                                  backgroundColor: "#eeeeee",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  fontSize: "16px",
                                  flexShrink: 0,
                                }}
                              >
                                <span>{index + 2}</span>

                                <button
                                  type="button"
                                  onClick={() =>
                                    handleRemoveAdditionalLossPayeeLimit(index)
                                  }
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "50%",
                                    border: "none",
                                    background: "#b5b5b5",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    lineHeight: "24px",
                                    padding: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  ×
                                </button>
                              </Box>

                              <Divider sx={{ flex: 1 }} />
                            </Box>
                          </Grid>
                        </Grid>

                        {/* NAME + LIMIT */}
                        <Grid container spacing={2}>

                          {/* NAME */}
                          <Grid size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth sx={{ mb: 1 }}>
                              <FormLabel>Name</FormLabel>
                            </FormControl>

                            <GlobalTextField
                              type="text"
                              placeH="Who is the Loss Payee?"
                              value={item.name}
                              onChange={(e) =>
                                handleAdditionalLossPayeeChange(
                                  index,
                                  "name",
                                  e.target.value
                                )
                              }
                              id={`additional_loss_payee_name_${index}`}
                              name={`additional_loss_payee_limit[${index}].name`}
                            />
                          </Grid>

                          {/* LIMIT */}
                          <Grid size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth sx={{ mb: 1 }}>
                              <FormLabel>Limit</FormLabel>
                            </FormControl>

                            <GlobalTextField
                              type="text"
                              placeH="$"
                              value={item.limit}
                              onChange={(e) =>
                                handleAdditionalLossPayeeLimitChange(e, index)
                              }
                              id={`additional_loss_payee_limit_${index}`}
                              name={`additional_loss_payee_limit[${index}].limit`}
                            />
                          </Grid>

                        </Grid>
                      </Box>
                    ))}
                  </Grid>
                ) : null}
              </Grid>

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>TRIA insurance?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.tria_insurance == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("tria_insurance", 1);
                        }}
                        error={
                          formik.touched.tria_insurance &&
                          Boolean(formik.errors.tria_insurance)
                        }
                        errorText={
                          formik.touched.tria_insurance &&
                          formik.errors.tria_insurance
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.tria_insurance != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            tria_insurance: 0,
                            //insurance_amount: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* {formik.values.tria_insurance == 1 ? (
                  <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth>
                      <FormLabel>Amount *</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextField
                          type="text"
                          placeH="$"
                          value={formik.values.insurance_amount}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          id="insurance_amount"
                          name="insurance_amount"
                          error={
                            formik.touched.insurance_amount &&
                            Boolean(formik.errors.insurance_amount)
                          }
                          helperText={
                            formik.touched.insurance_amount &&
                            formik.errors.insurance_amount
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              </Grid>

              {/* <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Employee Dishonesty Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.employee_dishonesty == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("employee_dishonesty", 1);
                        }}
                        error={
                          formik.touched.employee_dishonesty &&
                          Boolean(formik.errors.employee_dishonesty)
                        }
                        errorText={
                          formik.touched.employee_dishonesty &&
                          formik.errors.employee_dishonesty
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.employee_dishonesty != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            employee_dishonesty: 0,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid> */}

              {/* {formik.values.employee_dishonesty == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.employee_dishonesty_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "employee_dishonesty_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="employee_dishonesty_comment"
                          name="employee_dishonesty_comment"
                          error={
                            formik.touched.employee_dishonesty_comment &&
                            Boolean(formik.errors.employee_dishonesty_comment)
                          }
                          helperText={
                            formik.touched.employee_dishonesty_comment &&
                            formik.errors.employee_dishonesty_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              {/* </Grid> */}

              <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>TPI (3RD Party Dishonesty) Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.tpi == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("tpi", 1);
                        }}
                        error={formik.touched.tpi && Boolean(formik.errors.tpi)}
                        errorText={formik.touched.tpi && formik.errors.tpi}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.tpi != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            tpi: 0,
                            // tpi_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid> */}

                {/* {formik.values.tpi == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.tpi_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "tpi_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="tpi_comment"
                          name="tpi_comment"
                          error={
                            formik.touched.tpi_comment &&
                            Boolean(formik.errors.tpi_comment)
                          }
                          helperText={
                            formik.touched.tpi_comment &&
                            formik.errors.tpi_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              </Grid>

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Carryings at Exhibitions Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.carryings_exhibitions == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("carryings_exhibitions", 1);
                        }}
                        error={
                          formik.touched.carryings_exhibitions &&
                          Boolean(formik.errors.carryings_exhibitions)
                        }
                        errorText={
                          formik.touched.carryings_exhibitions &&
                          formik.errors.carryings_exhibitions
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.carryings_exhibitions != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            carryings_exhibitions: 0,
                            // carryings_exhibitions_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* {formik.values.carryings_exhibitions == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.carryings_exhibitions_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "carryings_exhibitions_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="carryings_exhibitions_comment"
                          name="carryings_exhibitions_comment"
                          error={
                            formik.touched.carryings_exhibitions_comment &&
                            Boolean(formik.errors.carryings_exhibitions_comment)
                          }
                          helperText={
                            formik.touched.carryings_exhibitions_comment &&
                            formik.errors.carryings_exhibitions_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              </Grid>

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Roadstock Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.roadstock == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("roadstock", 1);
                        }}
                        error={
                          formik.touched.roadstock &&
                          Boolean(formik.errors.roadstock)
                        }
                        errorText={
                          formik.touched.roadstock && formik.errors.roadstock
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.roadstock != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            roadstock: 0,
                            // roadstock_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* {formik.values.roadstock == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.roadstock_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "roadstock_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="roadstock_comment"
                          name="roadstock_comment"
                          error={
                            formik.touched.roadstock_comment &&
                            Boolean(formik.errors.roadstock_comment)
                          }
                          helperText={
                            formik.touched.roadstock_comment &&
                            formik.errors.roadstock_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Memo Extension Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.memo_extension == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("memo_extension", 1);
                        }}
                        error={
                          formik.touched.memo_extension &&
                          Boolean(formik.errors.memo_extension)
                        }
                        errorText={
                          formik.touched.memo_extension &&
                          formik.errors.memo_extension
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.memo_extension != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            memo_extension: 0,
                            // memo_extension_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* {formik.values.memo_extension == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.memo_extension_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "memo_extension_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="memo_extension_comment"
                          name="memo_extension_comment"
                          error={
                            formik.touched.memo_extension_comment &&
                            Boolean(formik.errors.memo_extension_comment)
                          }
                          helperText={
                            formik.touched.memo_extension_comment &&
                            formik.errors.memo_extension_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Joint Venture Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.joint_venture == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("joint_venture", 1);
                        }}
                        error={
                          formik.touched.joint_venture &&
                          Boolean(formik.errors.joint_venture)
                        }
                        errorText={
                          formik.touched.joint_venture &&
                          formik.errors.joint_venture
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.joint_venture != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            joint_venture: 0,
                            // joint_venture_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* {formik.values.joint_venture == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.joint_venture_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "joint_venture_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="joint_venture_comment"
                          name="joint_venture_comment"
                          error={
                            formik.touched.joint_venture_comment &&
                            Boolean(formik.errors.joint_venture_comment)
                          }
                          helperText={
                            formik.touched.joint_venture_comment &&
                            formik.errors.joint_venture_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Incoming Shipments Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.incoming_shipments == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("incoming_shipments", 1);
                        }}
                        error={
                          formik.touched.incoming_shipments &&
                          Boolean(formik.errors.incoming_shipments)
                        }
                        errorText={
                          formik.touched.incoming_shipments &&
                          formik.errors.incoming_shipments
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.incoming_shipments != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            incoming_shipments: 0,
                            // incoming_shipments_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* {formik.values.incoming_shipments == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.incoming_shipments_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "incoming_shipments_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="incoming_shipments_comment"
                          name="incoming_shipments_comment"
                          error={
                            formik.touched.incoming_shipments_comment &&
                            Boolean(formik.errors.incoming_shipments_comment)
                          }
                          helperText={
                            formik.touched.incoming_shipments_comment &&
                            formik.errors.incoming_shipments_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Excess Shipments Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.excess_shipments == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("excess_shipments", 1);
                        }}
                        error={
                          formik.touched.excess_shipments &&
                          Boolean(formik.errors.excess_shipments)
                        }
                        errorText={
                          formik.touched.excess_shipments &&
                          formik.errors.excess_shipments
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.excess_shipments != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            excess_shipments: 0,
                            // excess_shipments_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* {formik.values.excess_shipments == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.excess_shipments_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "excess_shipments_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="excess_shipments_comment"
                          name="excess_shipments_comment"
                          error={
                            formik.touched.excess_shipments_comment &&
                            Boolean(formik.errors.excess_shipments_comment)
                          }
                          helperText={
                            formik.touched.excess_shipments_comment &&
                            formik.errors.excess_shipments_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Trunk Show Extension Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.trunk_show_exhibition == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("trunk_show_exhibition", 1);
                        }}
                        error={
                          formik.touched.trunk_show_exhibition &&
                          Boolean(formik.errors.trunk_show_exhibition)
                        }
                        errorText={
                          formik.touched.trunk_show_exhibition &&
                          formik.errors.trunk_show_exhibition
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.trunk_show_exhibition != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            trunk_show_exhibition: 0,
                            // trunk_show_exhibition_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* {formik.values.trunk_show_exhibition == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.trunk_show_exhibition_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "trunk_show_exhibition_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="trunk_show_exhibition_comment"
                          name="trunk_show_exhibition_comment"
                          error={
                            formik.touched.trunk_show_exhibition_comment &&
                            Boolean(formik.errors.trunk_show_exhibition_comment)
                          }
                          helperText={
                            formik.touched.trunk_show_exhibition_comment &&
                            formik.errors.trunk_show_exhibition_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
              </Grid>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Travel Limit Increase Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.travel_insurance_increase == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("travel_insurance_increase", 1);
                        }}
                        error={
                          formik.touched.travel_insurance_increase &&
                          Boolean(formik.errors.travel_insurance_increase)
                        }
                        errorText={
                          formik.touched.travel_insurance_increase &&
                          formik.errors.travel_insurance_increase
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.travel_insurance_increase != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            travel_insurance_increase: 0,
                            travel_insurance_name: "",
                            travel_insurance_limit: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {formik.values.travel_insurance_increase == 1 ? (
                  <Grid size={{ xs: 12, md: 12 }}>

                    {/* EXISTING TRAVEL LIMIT */}
                    <Grid container spacing={2} sx={{ mt: 0 }}>

                      {/* NAME */}
                      <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <FormLabel>Name *</FormLabel>
                        </FormControl>

                        <GlobalTextField
                          type="text"
                          placeH=""
                          value={formik.values.travel_insurance_name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          id="travel_insurance_name"
                          name="travel_insurance_name"
                          error={
                            formik.touched.travel_insurance_name &&
                            Boolean(formik.errors.travel_insurance_name)
                          }
                          helperText={
                            formik.touched.travel_insurance_name &&
                            formik.errors.travel_insurance_name
                          }
                        />
                      </Grid>

                      {/* LIMIT */}
                      <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <FormLabel>Limit *</FormLabel>
                        </FormControl>

                        <GlobalTextField
                          type="text"
                          placeH="$"
                          value={formik.values.travel_insurance_limit}
                          onChange={(e) =>
                            handleAmountFieldChange(e, "travel_insurance_limit")
                          }
                          onBlur={formik.handleBlur}
                          id="travel_insurance_limit"
                          name="travel_insurance_limit"
                          error={
                            formik.touched.travel_insurance_limit &&
                            Boolean(formik.errors.travel_insurance_limit)
                          }
                          helperText={
                            formik.touched.travel_insurance_limit &&
                            formik.errors.travel_insurance_limit
                          }
                        />
                      </Grid>

                      {/* ADD BUTTON - BESIDE LIMIT */}
                      <Grid
                        size={{ xs: 12, md: 4 }}
                        sx={{
                          display: "flex",
                          alignItems: "flex-end",
                          pb: "4px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={handleAddAdditionalTravelLimit}
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                            fontSize: "16px",
                            padding: 0,
                            marginLeft: "8px",
                          }}
                        >
                          <span
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "50%",
                              background: "#000",
                              color: "#fff",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "22px",
                              fontWeight: "400",
                              lineHeight: 1,
                            }}
                          >
                            +
                          </span>

                          <span>Add</span>
                        </button>
                      </Grid>
                    </Grid>

                    {/* ADDITIONAL TRAVEL LIMITS */}
                    {formik.values.additional_travel_limit?.map((item, index) => (
                      <Box key={index} sx={{ mt: 4 }}>

                        {/* SEPARATOR
            IMPORTANT:
            Keep it inside md=8 so it doesn't stretch
            across the entire page.
        */}
                        <Grid container>
                          <Grid size={{ xs: 12, md: 8 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                mb: 3.5,
                              }}
                            >
                              {/* LEFT LINE */}
                              <Divider sx={{ flex: 1 }} />

                              {/* NUMBER + REMOVE */}
                              <Box
                                sx={{
                                  mx: 1.5,
                                  px: 1.5,
                                  height: 42,
                                  borderRadius: "24px",
                                  backgroundColor: "#eeeeee",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  fontSize: "16px",
                                  flexShrink: 0,
                                }}
                              >
                                <span>{index + 2}</span>

                                <button
                                  type="button"
                                  onClick={() =>
                                    handleRemoveAdditionalTravelLimit(index)
                                  }
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "50%",
                                    border: "none",
                                    background: "#b5b5b5",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    lineHeight: "24px",
                                    padding: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  ×
                                </button>
                              </Box>

                              {/* RIGHT LINE */}
                              <Divider sx={{ flex: 1 }} />
                            </Box>
                          </Grid>
                        </Grid>

                        {/* NAME + LIMIT */}
                        <Grid container spacing={2}>

                          {/* NAME */}
                          <Grid size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth sx={{ mb: 1 }}>
                              <FormLabel>Name</FormLabel>
                            </FormControl>

                            <GlobalTextField
                              type="text"
                              placeH=""
                              value={item.name}
                              onChange={(e) =>
                                handleAdditionalTravelChange(
                                  index,
                                  "name",
                                  e.target.value
                                )
                              }
                              onBlur={() =>
                                formik.setFieldTouched(
                                  `additional_travel_limit[${index}].name`,
                                  true
                                )
                              }
                              id={`additional_travel_name_${index}`}
                              name={`additional_travel_limit[${index}].name`}
                              error={
                                formik.touched.additional_travel_limit?.[index]?.name &&
                                Boolean(
                                  formik.errors.additional_travel_limit?.[index]?.name
                                )
                              }
                              helperText={
                                formik.touched.additional_travel_limit?.[index]?.name &&
                                formik.errors.additional_travel_limit?.[index]?.name
                              }
                            />
                          </Grid>

                          {/* LIMIT */}
                          <Grid size={{ xs: 12, md: 4 }}>
                            <FormControl fullWidth sx={{ mb: 1 }}>
                              <FormLabel>Limit</FormLabel>
                            </FormControl>

                            <GlobalTextField
                              type="text"
                              placeH="$"
                              value={item.limit}
                              onChange={(e) =>
                                handleAdditionalTravelLimitChange(e, index)
                              }
                              onBlur={() =>
                                formik.setFieldTouched(
                                  `additional_travel_limit[${index}].limit`,
                                  true
                                )
                              }
                              id={`additional_travel_limit_${index}`}
                              name={`additional_travel_limit[${index}].limit`}
                              error={
                                formik.touched.additional_travel_limit?.[index]?.limit &&
                                Boolean(
                                  formik.errors.additional_travel_limit?.[index]?.limit
                                )
                              }
                              helperText={
                                formik.touched.additional_travel_limit?.[index]?.limit &&
                                formik.errors.additional_travel_limit?.[index]?.limit
                              }
                            />
                          </Grid>

                        </Grid>
                      </Box>
                    ))}
                  </Grid>
                ) : null}
              </Grid>

              {/* Basis of Valuation Clause */}
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Basis of Valuation Clause</FormLabel>
                  </FormControl>

                  {/* <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.basis_of_valuation_clause == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("basis_of_valuation_clause", 1);
                        }}
                        error={
                          formik.touched.basis_of_valuation_clause &&
                          Boolean(formik.errors.basis_of_valuation_clause)
                        }
                        errorText={
                          formik.touched.basis_of_valuation_clause &&
                          formik.errors.basis_of_valuation_clause
                        }
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.basis_of_valuation_clause != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            basis_of_valuation_clause: 0,
                            basis_valuation_own_goods: null,
                            basis_valuation_inward_outward: null,
                            basis_valuation_goods_sold: null,
                            basis_valuation_sendings: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid> */}
                </Grid>
              </Grid>

              {/* {formik.values.basis_of_valuation_clause == 1 && ( */}
              <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* Own Goods */}
                <Grid size={{ xs: 12, md: 4 }}>
                  <FormControl fullWidth>
                    <FormLabel>Own Goods </FormLabel>
                  </FormControl>

                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                      <GlobalTextField
                        type="text"
                        placeH="Enter value"
                        value={formik.values.basis_valuation_own_goods}
                        // onChange={(e) =>
                        //   handleAmountFieldChange(e, "basis_valuation_own_goods")
                        // }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="basis_valuation_own_goods"
                        name="basis_valuation_own_goods"
                        error={
                          formik.touched.basis_valuation_own_goods &&
                          Boolean(formik.errors.basis_valuation_own_goods)
                        }
                        helperText={
                          formik.touched.basis_valuation_own_goods &&
                          formik.errors.basis_valuation_own_goods
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Inward / Outward */}
                <Grid size={{ xs: 12, md: 4 }}>
                  <FormControl fullWidth>
                    <FormLabel>Inward / Outward Memo </FormLabel>
                  </FormControl>

                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                      <GlobalTextField
                        type="text"
                        placeH="Enter value"
                        value={formik.values.basis_valuation_inward_outward}
                        // onChange={(e) =>
                        //   handleAmountFieldChange(e, "basis_valuation_inward_outward")
                        // }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="basis_valuation_inward_outward"
                        name="basis_valuation_inward_outward"
                        error={
                          formik.touched.basis_valuation_inward_outward &&
                          Boolean(formik.errors.basis_valuation_inward_outward)
                        }
                        helperText={
                          formik.touched.basis_valuation_inward_outward &&
                          formik.errors.basis_valuation_inward_outward
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* )} */}
              {/* {formik.values.basis_of_valuation_clause == 1 && ( */}
              <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* Goods Sold & Not Yet Delivered */}
                <Grid size={{ xs: 12, md: 4 }}>
                  <FormControl fullWidth>
                    <FormLabel>Goods Sold &amp; Not Yet Delivered </FormLabel>
                  </FormControl>

                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                      <GlobalTextField
                        type="text"
                        placeH="Enter value"
                        value={formik.values.basis_valuation_goods_sold}
                        // onChange={(e) =>
                        //   handleAmountFieldChange(e, "basis_valuation_goods_sold")
                        // }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="basis_valuation_goods_sold"
                        name="basis_valuation_goods_sold"
                        error={
                          formik.touched.basis_valuation_goods_sold &&
                          Boolean(formik.errors.basis_valuation_goods_sold)
                        }
                        helperText={
                          formik.touched.basis_valuation_goods_sold &&
                          formik.errors.basis_valuation_goods_sold
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Sendings */}
                <Grid size={{ xs: 12, md: 4 }}>
                  <FormControl fullWidth>
                    <FormLabel>Sendings </FormLabel>
                  </FormControl>

                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
                      <GlobalTextField
                        type="text"
                        placeH="Enter value"
                        value={formik.values.basis_valuation_sendings}
                        // onChange={(e) =>
                        //   handleAmountFieldChange(e, "basis_valuation_sendings")
                        // }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="basis_valuation_sendings"
                        name="basis_valuation_sendings"
                        error={
                          formik.touched.basis_valuation_sendings &&
                          Boolean(formik.errors.basis_valuation_sendings)
                        }
                        helperText={
                          formik.touched.basis_valuation_sendings &&
                          formik.errors.basis_valuation_sendings
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* )} */}

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Territorial Limit Extension Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={
                          formik.values.territorial_limit_extension == 1
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue(
                            "territorial_limit_extension",
                            1
                          );
                        }}
                        error={
                          formik.touched.territorial_limit_extension &&
                          Boolean(formik.errors.territorial_limit_extension)
                        }
                        errorText={
                          formik.touched.territorial_limit_extension &&
                          formik.errors.territorial_limit_extension
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={
                          formik.values.territorial_limit_extension != 1
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            territorial_limit_extension: 0,
                            // territorial_limit_extension_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Overnight Shipmentss Limit Extension Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={
                          formik.values.overnight_shipments_extension_clause == 1
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue(
                            "overnight_shipments_extension_clause",
                            1
                          );
                        }}
                        error={
                          formik.touched.overnight_shipments_extension_clause &&
                          Boolean(formik.errors.territorial_limiovernight_shipments_extension_clause_extension)
                        }
                        errorText={
                          formik.touched.overnight_shipments_extension_clause &&
                          formik.errors.overnight_shipments_extension_clause
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={
                          formik.values.overnight_shipments_extension_clause != 1
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            overnight_shipments_extension_clause: 0,
                            // territorial_limit_extension_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>



                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Locked Showcase Endorsement Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={
                          formik.values.locked_showcase_endorsement_clause == 1
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue(
                            "locked_showcase_endorsement_clause",
                            1
                          );
                        }}
                        error={
                          formik.touched.locked_showcase_endorsement_clause &&
                          Boolean(formik.errors.locked_showcase_endorsement_clause)
                        }
                        errorText={
                          formik.touched.locked_showcase_endorsement_clause &&
                          formik.errors.locked_showcase_endorsement_clause
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={
                          formik.values.locked_showcase_endorsement_clause != 1
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            locked_showcase_endorsement_clause: 0,
                            // territorial_limit_extension_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>


                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Show Window Display Extension Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={
                          formik.values.window_display_extension_clause == 1
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue(
                            "window_display_extension_clause",
                            1
                          );
                        }}
                        error={
                          formik.touched.window_display_extension_clause &&
                          Boolean(formik.errors.window_display_extension_clause)
                        }
                        errorText={
                          formik.touched.window_display_extension_clause &&
                          formik.errors.window_display_extension_clause
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={
                          formik.values.window_display_extension_clause != 1
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            window_display_extension_clause: 0,
                            // territorial_limit_extension_comment: null,
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>




                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Deductible Amendment Clause?</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="Yes"
                        selected={formik.values.deductible_amendment_clause == 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setFieldValue("deductible_amendment_clause", 1);
                        }}
                        error={
                          formik.touched.deductible_amendment_clause &&
                          Boolean(formik.errors.deductible_amendment_clause)
                        }
                        errorText={
                          formik.touched.deductible_amendment_clause &&
                          formik.errors.deductible_amendment_clause
                        }
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalRadio
                        title="No"
                        selected={formik.values.deductible_amendment_clause != 1}
                        onClick={(e) => {
                          e.preventDefault();
                          formik.setValues((prevValues) => ({
                            ...prevValues,
                            deductible_amendment_clause: 0,
                            deductible_amendment_value: null,

                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>
                  {formik.values.deductible_amendment_clause == 1 ? (
                    // <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 8 }}>
                      <FormControl fullWidth>
                        <FormLabel>Details *</FormLabel>
                      </FormControl>
                      <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                          <GlobalTextAriaField
                            type="text"
                            placeH="This will be shown in the policy after: 'It is hereby understood and agreed that the Deductible in respect of'"
                            row="3"
                            value={formik.values.deductible_amendment_value}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            id="deductible_amendment_value"
                            name="deductible_amendment_value"
                            error={
                              formik.touched.deductible_amendment_value &&
                              Boolean(formik.errors.deductible_amendment_value)
                            }
                            helperText={
                              formik.touched.deductible_amendment_value &&
                              formik.errors.deductible_amendment_value
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}

                </Grid>



                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel>Deductible</FormLabel>
                  </FormControl>
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalTextField
                        type="text"
                        placeH="On Premises"
                        value={formik.values.on_premises_deductible}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "on_premises_deductible")
                        }
                        onBlur={formik.handleBlur}
                        id="on_premises_deductible"
                        name="on_premises_deductible"
                        error={
                          formik.touched.on_premises_deductible &&
                          Boolean(formik.errors.on_premises_deductible)
                        }
                        helperText={
                          formik.touched.on_premises_deductible &&
                          formik.errors.on_premises_deductible
                        }
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                      <GlobalTextField
                        type="text"
                        placeH="Off Premises"
                        value={formik.values.off_premises_deductible}
                        onChange={(e) =>
                          handleAmountFieldChange(e, "off_premises_deductible")
                        }
                        onBlur={formik.handleBlur}
                        id="off_premises_deductible"
                        name="off_premises_deductible"
                        error={
                          formik.touched.off_premises_deductible &&
                          Boolean(formik.errors.off_premises_deductible)
                        }
                        helperText={
                          formik.touched.off_premises_deductible &&
                          formik.errors.off_premises_deductible
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* 
                {formik.values.territorial_limit_extension == 1 ? (
                  <Grid size={{ xs: 12, md: 8 }}>
                    <FormControl fullWidth>
                      <FormLabel>Comments (if any)</FormLabel>
                    </FormControl>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                        <GlobalTextAriaField
                          row={2}
                          placeH="Type here..."
                          type="comment"
                          value={formik.values.territorial_limit_extension_comment}
                          onChange={(e) =>
                            handleAmountFieldChange(
                              e,
                              "territorial_limit_extension_comment"
                            )
                          }
                          onBlur={formik.handleBlur}
                          id="territorial_limit_extension_comment"
                          name="territorial_limit_extension_comment"
                          error={
                            formik.touched.territorial_limit_extension_comment &&
                            Boolean(formik.errors.territorial_limit_extension_comment)
                          }
                          helperText={
                            formik.touched.territorial_limit_extension_comment &&
                            formik.errors.territorial_limit_extension_comment
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null} */}
                <Grid size={{ xs: 12, md: 8 }}>
                  <FormControl fullWidth>
                    <FormLabel sx={{ mb: 1 }}>Comments (if any)</FormLabel>
                  </FormControl>
                  <Editor
                    id="comment"
                    name="comment"
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.comment && Boolean(formik.errors.comment)
                    }
                    helperText={formik.touched.comment && formik.errors.comment}
                  />

                  {/* <GlobalTextAriaField
                    row={2}
                    placeH="Type here..."
                    id="comment"
                    name="comment"
                    type="comment"
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.comment && Boolean(formik.errors.comment)
                    }
                    helperText={formik.touched.comment && formik.errors.comment}
                  /> */}
                </Grid>
              </Grid>
            </form>
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            // areRequiredFieldsFilled(formik) &&
            formik.values.setting_unsetting !== "" &&
            (formik.values.employee_infidelity !== "") & !formik.dirty &&
            propStep11DataMemoize !== null
          }
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
      </section>
    </>
  );
};

export default StepElevenForm;
